import { FC } from 'react'
import styled, { css } from 'styled-components'
import { ArrowLeft } from 'svgIcons'

interface IFLeftBackButtonProps {
  label: string
  onClick: () => void
  className?: string
}

const LeftBackButton: FC<IFLeftBackButtonProps> = ({
  label,
  onClick,
  className,
}) => {
  return (
    <StyledWrapper className={className} onClick={onClick}>
      <ArrowLeft className="arrow-left" />
      <div>{label}</div>
    </StyledWrapper>
  )
}

export default LeftBackButton

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    display: inline-flex;
    width: 100%;
    padding: 11px 15px;
    font-size: 13px;
    font-weight: 500;
    color: ${theme.color.text_1};
    background-color: ${theme.background.bg_3};

    .arrow-left {
      width: 16px;
      height: 16px;
      padding: 2px;
      margin-right: 8px;
    }
  `}
`
